// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__Header__3PdNJ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Header/Header.css
// module id = 141
// module chunks = 0